/**
 * Highest position among the existing option values, so a quick-created value
 * can be appended after them (mirrors the /option_values page behavior).
 */
export default function getLastPosition(optionValues) {
    return (optionValues ?? []).reduce(
        (lastPosition, optionValue) => Math.max(lastPosition, optionValue.position ?? 0),
        0
    );
}
